import { axios } from '@/lib/axios';
import { useQuery } from 'react-query';

export type Publisher = {
    id: number;
    name: string;
};

const fetchPublishers = (): Promise<Publisher[]> => axios.get('/api/free/publisher');

export const usePublishers = () =>
    useQuery<Publisher[]>({
        queryKey: ['publishers'],
        queryFn: fetchPublishers,
        staleTime: 10 * 60 * 1000,
        useErrorBoundary: (error: any) => error?.response?.status >= 400,
    });
